export default __webpack_public_path__ + "static/media/IRIS-logo-Transprenet-white.11461caf.svg";